// extracted by mini-css-extract-plugin
module.exports = {"tab":"CharacterSheetSection_tab_2Ud7I","selectedTab":"CharacterSheetSection_selectedTab_1ALCm","tabButton":"CharacterSheetSection_tabButton_2dUfO"};